import MerchantWidgetCalendarPage, {
  PageProps,
} from '../../../components/merchants/calendar/MerchantWidgetCalendarPage';
import * as React from 'react';
import { Dispatch } from 'redux';
import { UAParser } from 'ua-parser-js';
import { Actions, init } from '../../../redux/actions/merchants/services';
import MetaTags from '../../../components/common/layouts/MetaTags';
import implUCMerchantRepository from '../../../infrastructure/repositories/UCMerchantRepository';
import { FullCalendarViewStyle } from '../../../domain/entities/BookingEvent';

const FromTypes = {
  DAY: 'agendaDay',
  THREE_DAY: 'agendaThreeDay',
  WEEK: 'agendaWeek',
  MONTH: 'month',
  LIST: 'listMonth',
} as const;
type FromType = typeof FromTypes[keyof typeof FromTypes];
const CalendarViewStyles = new Map([
  [FromTypes.DAY, FullCalendarViewStyle.timeGridDay],
  [FromTypes.THREE_DAY, FullCalendarViewStyle.timeGridThreeDay],
  [FromTypes.WEEK, FullCalendarViewStyle.timeGridWeek],
  [FromTypes.MONTH, FullCalendarViewStyle.dayGridMonth],
  [FromTypes.LIST, FullCalendarViewStyle.listMonth],
]);

interface Query {
  publicId: string;
  from_pc?: FromType;
  from_sp?: FromType;
  servicePublicIds?: string;
  _ga?: string;
}

interface Props extends PageProps {
  publicId: string;
  calendarViewStyle: string;
  ga?: string;
  servicePublicIds?: number[];
}

class MerchantWidgetCalendar extends React.Component<Props> {
  public constructor(props: Props) {
    super(props);
  }

  public static async getInitialProps({
    req,
    query,
    store: { dispatch },
  }: {
    req: any;
    query: Query;
    store: {
      dispatch: Dispatch<Actions>;
    };
  }) {
    const uaParser = new UAParser(req.headers['user-agent']);
    const device = uaParser.getDevice();

    const isSp = device.type !== undefined;
    let calendarViewStyle = query.from_pc
      ? CalendarViewStyles.get(query.from_pc)
      : FullCalendarViewStyle.dayGridMonth;
    if (isSp) {
      calendarViewStyle = query.from_sp
        ? CalendarViewStyles.get(query.from_sp)
        : FullCalendarViewStyle.timeGridThreeDay;
    }

    const layout = await implUCMerchantRepository().Layout(query.publicId);
    dispatch(init(layout.merchant.publicId, layout.merchant.timeZone));

    return {
      merchant: layout.merchant,
      calendarViewStyle,
      ga: query._ga,
      servicePublicIds: query.servicePublicIds,
    };
  }

  public render() {
    return (
      <>
        <style>
          {/* デフォで当たるbodyとFullCalendarのレイアウトをRails(slim)からの移行都合で上書きしている */}
          {`body { 
                min-width: 100% !important;
              }

              .fc .fc-daygrid-body-natural .fc-daygrid-day-events {
                margin-bottom: 0px !important;
              }
              
              .fc .fc-daygrid-event-harness .fc-daygrid-event .fc-event-main-frame {
                padding: 0 !important;
              }

              .fc-col-header-cell-cushion {
                font-size: 12px;
              }

              .fc .fc-toolbar h2 {
                font-size: 100%;
              }

              .fc .fc-toolbar {
                flex-wrap: wrap;
                flex-direction: row;
              }

              @media screen and (max-width:480px) {
                .fc-toolbar-chunk {
                  margin-top: 15px;
                }
              }
          `}
        </style>
        {/* クローラーにindexされたくない */}
        <MetaTags noIndex={true} />
        <MerchantWidgetCalendarPage {...this.props} />
      </>
    );
  }
}

export default MerchantWidgetCalendar;
